/** * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Events namespace agreement - [namespace:module|kind:action] like [sdk:track:play] or [widget:song:onload]
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * **/

import { SDKCustomEvent, SDKEvent } from '..'
import { EVENT_PLAYBACK_STATUS } from '../../constants/enums'
import { ChapterData } from '../../services/telemetry/video/events'

/** * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *                                Events List
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * **/

export const VIDEO_PLAYBACK_INITIATED = new SDKEvent('video:player:initiated')
export const VIDEO_PLAYBACK_ERROR = new SDKEvent('video:player:error')
export const VIDEO_PLAYBACK_LOAD_START = new SDKEvent('video:player:load:end')
export const VIDEO_PLAYBACK_LOAD_END = new SDKEvent('video:player:load:start')
export const VIDEO_PLAYBACK_LOAD_ERROR = new SDKEvent('video:player:load:error')
export const VIDEO_PLAYBACK_START = new SDKEvent('video:player:start')
export const VIDEO_PLAYBACK_PAUSE = new SDKEvent('video:player:pause')
export const VIDEO_PLAYBACK_ENDED = new SDKEvent('video:player:ended')

export const VIDEO_PLAYER_MOUNTED = new SDKEvent('video:player:mounted')
export const VIDEO_PLAYER_UNMOUNTED = new SDKEvent('video:player:unmounted')

/** * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *                                CustomEvents List
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * **/
export const VIDEO_PLAYBACK_TIME = (time: number | undefined, ranges: TimeRanges | undefined, duration: number | undefined) =>
  new SDKCustomEvent<{ time: number, ranges: TimeRanges, duration: number }>(VIDEO_PLAYBACK_TIME.type, { detail: { time, ranges, duration } })
VIDEO_PLAYBACK_TIME.type = 'video:player:time'

export const VIDEO_PLAYBACK_SEEK = (time: number | undefined, destinationTime: number | undefined) =>
  new SDKCustomEvent<{ time: number, destinationTime: number }>(VIDEO_PLAYBACK_SEEK.type, { detail: { time, destinationTime } })
VIDEO_PLAYBACK_SEEK.type = 'video:player:seek'

export const VIDEO_PLAYBACK_CHAPTER_START = (chapter: ChapterData) =>
  new SDKCustomEvent<{ chapter: ChapterData }>(VIDEO_PLAYBACK_CHAPTER_START.type, { detail: { chapter } })
VIDEO_PLAYBACK_CHAPTER_START.type = 'video:player:chapter:start'

export const VIDEO_PLAYBACK_CHAPTER_END = (previousChapter: ChapterData, chapter: ChapterData, reason: EVENT_PLAYBACK_STATUS) =>
  new SDKCustomEvent<{ chapter: ChapterData, previousChapter: ChapterData, reason: EVENT_PLAYBACK_STATUS }>(VIDEO_PLAYBACK_CHAPTER_END.type, { detail: { previousChapter, chapter, reason } })
VIDEO_PLAYBACK_CHAPTER_END.type = 'video:player:chapter:end'

export const VIDEO_PLAYER_CHAPTERS_TOGGLE = (chapters: ChapterData[]) =>
  new SDKCustomEvent<ChapterData[]>(VIDEO_PLAYER_CHAPTERS_TOGGLE.type, { detail: chapters })
VIDEO_PLAYER_CHAPTERS_TOGGLE.type = 'video:player:chapters:toggle'

new SDKEvent('video:player:seek')
